import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Embed from 'v-video-embed'
import * as VueGoogleMaps from "vue2-google-maps";
import VueAnalytics from 'vue-ua'

Vue.config.productionTip = false
Vue.use(Embed);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyB3UDJGVC3kroeIHtjgrfoZgUlVE4FHD2g",
    libraries: "places"
  }
});

Vue.use(VueAnalytics, {
  appName: 'signelarsen.com',
  appVersion: '1.0.0',
  trackingId: 'UA-177364279-1',
  debug: true,
  vueRouter: router,
  ignoredViews: [],
  trackPage: true
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
